class LoadArticles {

  constructor() {
    this.button = document.querySelector('#get-articles')
    this.parent = document.querySelector('.blog-index__list')
    this.template = document.querySelector('#blog-preview-template')
    this.page = 2;
    this.tag = ""
    if (this.button) {
      this.listen()
    }
  }

  listen() {
    let query_url = `/api/collections/blog/entries?limit=9&sort=-date&filter[site]=default`
    const location_segments = window.location.pathname.split('/')
    if (location_segments[1] == 'post-tag') {
      this.tag = location_segments[2]
      query_url += `&filter[taxonomy:post_tag]=${this.tag}`
    }
    let featured_post = document.querySelector('.featured-post')
    if (featured_post) {
      let featured_post_id = featured_post.getAttribute('data-post-id')
      query_url += `&filter[id:isnt]=${featured_post_id}`
    }
    this.button.addEventListener('click', () => {
      fetch(`${query_url}&page=${this.page}`)
        .then(raw => raw.json()
          .then(res => {
            res.data.forEach((article, index) => {
              let preview = this.template.content.cloneNode(true)
              let date = this.format_date(new Date(article.date))
              let tags = this.split_tags(article.post_tag)
              preview.querySelector('.blog-preview__title').innerHTML = article.title
              preview.querySelector('.blog-preview__date').innerHTML = date
              preview.querySelector('.blog-preview').setAttribute('href', article.permalink)
              preview.querySelector('.blog-preview').setAttribute('data-tag', tags)
              let image = ""
              if (article.featured_image) {
                image = article.featured_image.permalink
              } else if (article.header) {
                image = article.header.permalink
              }
              preview.querySelector('.blog-preview__image').setAttribute('src', image)
              this.parent.appendChild(preview)
            })

            if (this.page < res.meta.last_page) {
              this.page++
            } else {
              this.button.remove()
            }
          }))
    })
  }

  format_date(date) {
    let dateString = ""
    // Example output: November 28th, 2023
    const month = date.toLocaleString('default', { month: 'long' })
    const formatted_date = date.getDate() + this.addOrdinal(date.getDate())
    const year = date.getFullYear()
    dateString = `${month} ${formatted_date}, ${year}`
    return dateString
  }

  split_tags(tags) {
    let output = ""
    tags.forEach((item, index) => {
      output += item.slug
      if (index < tags.length - 1) {
        output += ","
      }
    })
    return output
  }

  addOrdinal(number) {
    if (number > 3 && number < 21) return "th";
    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }



}

export default LoadArticles